import galeriaBonica from '../lib/galeria';

const galeria = () => {
    [].forEach.call(document.querySelectorAll('.galeria__imagenes'), (galeria: HTMLElement) => {
        galeriaBonica(galeria);
    });
}

export default galeria;